// extracted by mini-css-extract-plugin
export default {"selects":"Selects_selects__DdIvP","selectAlphaPopu":"Selects_selectAlphaPopu__-xRAm","select":"Selects_select__Z8hpk"};